<template>
  <v-btn icon color="primary" :loading="cargando" @click="generarPdf()" :disabled="disabled" class="inline-block">
    <v-img :src="require('../../../assets/iconos/pdf.png')" contain height="30"/>
  </v-btn>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import DescargasHelper from "@/comunes/helpers/DescargasHelper";
import "@/comunes/servicios/DescripcionesCeramicaServicio";

export default {
  name: "BtnPdf",
  props: {
    id: {required: true, type: Number},
    idProyecto: {required: true, type: Number},
    disabled: {type: Boolean, default: false}
  },
  data: () => ({
    cargando: false
  }),
  methods: {
    async generarPdf() {
      this.cargando = true;

      const descripcion = await HttpHelper.get(`solucion-constructiva/${this.id}/descripcion`);
      const descripcionGenerada = await window.DescripcionesCeramica.generar(this.idProyecto, this.id, descripcion.contenido);
      HttpHelper.post(`solucion-constructiva/${this.id}/pdf`, {descripcion: descripcionGenerada})
          .then((res) => {
            DescargasHelper.descargarBase64(res.nombre, res.dataB64, res.mime);
          })
          .finally(() => {
            this.cargando = false;
          });
    }
  }
}
</script>

<style scoped>

</style>